import { useState } from 'react';

export const useFiltersBeneficiados = () => {
  const [filtersBeneficiadosTable, setFiltersBeneficiadosTable] = useState({
    nombreBeneficiado: null,
    estado: null,
    tipoBeneficio: null,
    folioMonitoreo: null
  });

  return [filtersBeneficiadosTable, setFiltersBeneficiadosTable];
};

export const useFiltersCandidatosAp = () => {
  const [filtersCandidatosApTable, setFiltersCandidatosApTable] = useState({
    nombreCandidato: null,
    estado: null,
    cuentaRF: null,
    correoRF: null
  });

  return [filtersCandidatosApTable, setFiltersCandidatosApTable];
};
